import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import { CommunicationLayout, CommunicationWaitIllustration } from '../../../../components/Communication';
import { IBasePaymentCommunicationProps } from '../../types';
import { PAYMENT_PENDING_MESSAGE, PAYMENT_PENDING_TITLE } from './constants';

import * as styles from './styles.css';

export const PaymentPending: React.FC<IBasePaymentCommunicationProps> = ({ testId }) => {
  return (
    <CommunicationLayout
      image={<CommunicationWaitIllustration />}
      prependTitle={
        <div className={styles['loader-area']}>
          <Spinner size={18} color="primary_100" />
        </div>
      }
      title={PAYMENT_PENDING_TITLE}
      testId={testId}
      message={PAYMENT_PENDING_MESSAGE}
    />
  );
};

PaymentPending.displayName = 'PaymentPending';
